export const USER_V2_ROOT = '/v2/user'

export const isUserV2Path = (pathname) => (
  pathname === USER_V2_ROOT || pathname.indexOf(`${USER_V2_ROOT}/`) === 0
)
